<!--  -->
<template>
    <div class="gardenContentList">
        <div class="garden_name bgc box-shadow padding-20">
            <div class="content">
                <div class="left_name">
                    园区名称：{{params.name}}
                </div>
                <div @click="returnGardenList" class="right_return">返回园区列表</div>
            </div>
        </div>
        <div class="list_box bgc box-shadow padding-20">
            <div class="btn_search">
                <div class="left_btn">
                    <el-button type="primary" @click="addContent">添加内容</el-button>
                    <el-button @click="batchDelete">批量删除</el-button>
                </div>
                <div class="right_search">
                    <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="params.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <el-select v-model="params.status" placeholder="全部状态">
                        <el-option v-for="(item, index) in statusList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="params.columncode" placeholder="所属板块">
                        <el-option v-for="(item, index) in panelnameList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="params.isrecommend" placeholder="是否推荐">
                        <el-option v-for="(item, index) in recommendList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-input class="subject" v-model="params.subject" placeholder="请输入关键字"></el-input>
                    <el-button @click="handleSearch">搜索</el-button>
                </div>
            </div>
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column :selectable="screenCheckBox" type="selection" width="55"></el-table-column>
                <el-table-column label="标题" prop="subject" class-name="left"></el-table-column>
                <el-table-column label="所属版块" prop="columnname" width="80px" class-name="center"></el-table-column>
                <el-table-column label="发布日期" prop="releasetime" width="100px" class-name="center"></el-table-column>
                <el-table-column label="浏览量" prop="viewcount" width="80px" class-name="center"></el-table-column>
                <el-table-column label="是否推荐" prop="isrecommendname" width="80px" class-name="center"></el-table-column>
                <el-table-column label="发布状态" prop="statusname" width="80px" class-name="center">
                    <template slot-scope="scope">
                        <span :class="scope.row.status | filterStatus">{{scope.row.statusname}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="发布人" prop="hostname" width="150px" class-name="center"></el-table-column>
                <el-table-column label="创建时间" prop="datetime" width="120px" class-name="center"></el-table-column>
                <el-table-column label="操作" class-name="right" width="150px">
                    <template slot-scope="scope">
                        <span class="handle" @click="handleEdit(scope.row)" v-if="scope.row.status !== 100">编辑</span>
                        <span class="line" v-if="scope.row.status !== 100">|</span>
                        <span class="handle" @click="handleDelete(scope.row)" v-if="scope.row.status !== 100">删除</span>
                        <span class="line" v-if="scope.row.status !== 100">|</span>
                        <span class="handle" @click="handleCheck(scope.row)" v-if="scope.row.status === 100">查看</span>
                        <span class="line" v-if="scope.row.status === 100">|</span>
                        <span class="handle" @click="handleCopy(scope.row)">复制</span>
                    </template>
                </el-table-column>
            </el-table>
            <Page ref="page" :total="total" @getList="getList" />
        </div>
    </div>
</template>

<script>
import Page from 'base/page/page'
import {mapActions, mapGetters} from 'vuex'
import {getAllGovparkcontent, uploadGovparkcontentStatus} from 'api/gardenApi'
export default {
    data() {
        return {
            params: {
                date: [],
                status: '',
                isrecommend: '',
                columncode: '',
                subject: '',
                parkinnerid: this.$route.query.parkinnerid,
                name: this.$route.query.name
            },
            statusList: [
                {label: '全部状态', value: ' '},
                {label: '草稿', value: 0},
                {label: '已发布', value: 10},
                {label: '已删除', value: 100},
            ],
            panelnameList: [
                {label: '全部', value: ' '},
                {label: '明星企业', value: 1},
                {label: '营商环境', value: 2},
                {label: '区域政策', value: 3}
            ],
            recommendList: [
                {label: '全部', value: ' '},
                {label: '是', value: 1},
                {label: '否', value: 0}
            ],
            tableData: [],
            total: 0,
            selectList: []
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getList()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        returnGardenList() {
            this.$router.push({
                name: 'GardenList'
            })
        },
        handleSelectionChange(list) {
            this.selectList = list
        },
        batchDelete() {
            if (this.selectList.length) {
                this.$confirm('确定删除这些内容吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.setLoading(true)
                    let innerid = ''
                    this.selectList.forEach(item => {
                        innerid = innerid + item.innerid + ','
                    })
                    uploadGovparkcontentStatus({
                        data: {innerid: innerid},
                        success: res => {
                            this.setLoading(false)
                            this.tableData.forEach(item => {
                                this.selectList.forEach(options => {
                                    if (item.innerid === options.innerid) {
                                        item.status = 100
                                        item.statusname = '已删除'
                                    }
                                })
                            })
                            this.$refs.multipleTable.clearSelection()
                            console.log(this.selectList)
                            // row.status = 100
                            // row.statusname = '已删除'
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {
                })
            } else {
                this.$message.warning('请选择批量删除的内容')
            }
        },
        getList() {
            this.setLoading(true)
            const params = JSON.parse(JSON.stringify(this.params))
            if (params.isrecommend === ' ') {
                params.isrecommend = ''
            }
            if (params.status === ' ') {
                params.status = ''
            }
            if (params.columncode === ' ') {
                params.columncode = ''
            }
            if (params.date.length) {
                params.begintime = params.date[0]
                params.endtime = params.date[1]
            }
            getAllGovparkcontent({
                data: Object.assign({}, params, this.page),
                success: res => {
                    this.setLoading(false)
                    this.tableData = res.data.content
                    this.total = res.data.pageinfo.rowCount
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 添加内容
        addContent() {
            this.$router.push({name: 'GardenContentEdit', query: {parkinnerid: this.params.parkinnerid, name: this.params.name}})
        },
        handleEdit(row) {
            this.$router.push({name: 'GardenContentEdit', query: {parkinnerid: this.params.parkinnerid, innerid: row.innerid, name: this.params.name}})
        },
        handleDelete(row) {
            this.$confirm('确定删除该内容吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                uploadGovparkcontentStatus({
                    data: {innerid: row.innerid},
                    success: res => {
                        this.setLoading(false)
                        row.status = 100
                        row.statusname = '已删除'
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {
            })
        },
        handleCheck(row) {
            this.$router.push({name: 'GardenContentEdit', query: {parkinnerid: this.params.parkinnerid, innerid: row.innerid, name: this.params.name}})
        },
        handleCopy(row) {
            this.$router.push({name: 'GardenContentEdit', query: {parkinnerid: this.params.parkinnerid, iscopy: 1, innerid: row.innerid, name: this.params.name}})
        },
        handleSearch() {
            this.setPage({page: 1, pageSize: 10})
            this.getList()
        },
        screenCheckBox(row, index) {
            if (row.status === 10 || row.status === 0) {
                return true
            } else {
                return false
            }
        },
        ...mapActions(['setLoading', 'setPage'])
    },
    filters: {
        filterStatus(status) {
            let classname = ''
            switch(status) {
                case 0:
                    classname = 'status0'
                break
                case 10:
                    classname = 'status10'
                break
                case 100:
                    classname = 'status100'
                break
            }
            return classname
        }
    },
    computed: {
        ...mapGetters(['page'])
    },
    components: {
        Page
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .gardenContentList {
        .garden_name {
            margin-bottom: 20px;
            .content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: #FAFAFA;
                padding: 20px;
                .left_name {
                    font-size: 16px;
                    line-height: 22px;
                    font-weight: bold;
                }
                .right_return {
                    color: #409EFF;
                    font-size: 14px;
                    line-height: 20px;
                    cursor: pointer;
                }
            }
        }
        .list_box {
            .btn_search {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left_btn {
                    margin-bottom: 20px;
                    .el-button--primary {
                        margin-right: 20px;
                    }
                    .el-button--default {
                        margin-left: 0;
                    }
                }
                .right_search {
                    margin-bottom: 20px;
                    .el-date-editor {
                        margin-right: 20px;
                        width: 225px;
                        .el-input__icon, .el-range-separator {
                            line-height: 24px;
                        }
                    }
                    .el-select {
                        width: 108px;
                        min-width: 108px;
                        margin-right: 20px;
                        .el-select__caret {
                            line-height: 32px;
                        }
                    }
                    .subject {
                        width: 150px;
                        margin-right: 30px;
                    }
                }
            }
            .el-table {
                .left {
                    .cell {
                        text-align: left;
                    }
                }
                .center {
                    .cell {
                        text-align: center;
                    }
                }
                .right {
                    .cell {
                        text-align: right;
                    }
                }
                .status0 {
                    color: #606266;
                }
                .status10 {
                    color: #67C23A;
                }
                .status100 {
                    color: #999999;
                }
                .handle {
                    font-size: 14px;
                    cursor: pointer;
                    color: #439FFE;
                }
                .line {
                    font-size: 14px;
                    color: #439FFE;
                    margin: 0 5px;
                    position: relative;
                    top: -1px
                }
            }
        }
    }
</style>